module.exports = __webpack_public_path__ + "media/2_Long.36fc3b48.mp3";